<template>
	<v-col
		class="background"
		:style="{ 'background-image': background }"
	>
		<v-row class="mb-20">
			<v-col class="text-center big">
				<span>Winning Numbers</span>
			</v-col>
		</v-row>
		<v-row>
			<v-col class="text-center big" cols="4">
				<v-row>
					<v-col class="text-center">
						<img :src="getUrl(sortition.logo.normal.url)" alt="logo" class="lucky-logo"/>
					</v-col>
				</v-row>
				<v-row>
					<v-col class="text-center sortition-name">
						<span>{{ sortition.name }}</span>
					</v-col>
				</v-row>
				<v-row>
					<v-col class="text-center">
						<img :src="getUrl(sortition.logo.normal.url)" alt="logo" class="lucky-logo"/>
					</v-col>
				</v-row>
			</v-col>
			<v-col class="b-l-white align-self-center" cols="8">
				<v-row v-for="resultField in sortedResultsFields" :key="resultField">
					<v-col class="text-center" cols="5">
						<img :src="imageForPlayType(resultField)" alt="playType" class="pick"/>
					</v-col>
					<v-col cols="7">
						<img
							v-for="(result, index) in numbersForPlayType(resultField)"
							:key="index"
							:src="fieryBalls[parseInt(result, 10)]"
							alt="result"
							class="ball"
						/>
					</v-col>
				</v-row>
			</v-col>
		</v-row>
	</v-col>
</template>

<script>
	import ResultField from '../../enumerations/ResultField.json';
	import fiery0 from '../components/common/images/0.png';
	import fiery1 from '../components/common/images/1.png';
	import fiery2 from '../components/common/images/2.png';
	import fiery3 from '../components/common/images/3.png';
	import fiery4 from '../components/common/images/4.png';
	import fiery5 from '../components/common/images/5.png';
	import fiery6 from '../components/common/images/6.png';
	import fiery7 from '../components/common/images/7.png';
	import fiery8 from '../components/common/images/8.png';
	import fiery9 from '../components/common/images/9.png';

	import pick2 from '../components/common/images/pick2.png';
	import pick3 from '../components/common/images/pick3.png';
	import pick4 from '../components/common/images/pick4.png';
	import pick5 from '../components/common/images/pick5.png';
	import first from '../components/common/images/1st.png';
	import second from '../components/common/images/2nd.png';
	import third from '../components/common/images/3er.png';
	import background from '../components/common/images/background.jpg';

	export default {
		name: 'WinningNumbersDisplay',
		props: {
			result: {
				type: Object,
				required: true
			},
			sortition: {
				type: Object,
				required: true
			}
		},
		data() {
			return {
				fieryBalls: [
					fiery0,
					fiery1,
					fiery2,
					fiery3,
					fiery4,
					fiery5,
					fiery6,
					fiery7,
					fiery8,
					fiery9
				],
				background: background
			};
		},
		mounted() {
			this.$confetti.start();
			setTimeout(() => {
				this.$emit('show-board');
			}, 20000);
		},
		destroyed() {
			this.$confetti.stop();
		},
		methods: {
			getUrl(imgUrl) {
				return imgUrl;
			},
			imageForPlayType(playType) {
				switch (playType) {
					case ResultField.PickTwo:
						return pick2;
					case ResultField.CashThree:
						return pick3;
					case ResultField.PickFour:
						return pick4;
					case ResultField.PickFive:
						return pick5;
					case ResultField.First:
						return first;
					case ResultField.Second:
						return second;
					case ResultField.Third:
						return third;
				}
			},
			numbersForPlayType(playType) {
				switch (playType) {
					case ResultField.PickTwo:
						if (typeof this.result.first_number === 'number') {
							return this.result.first_number.toString().
								padStart(2, '0');
						}
						return '';
					case ResultField.CashThree:

						if (typeof this.result.cash_three === 'number') {
							return this.result.cash_three.toString().
								padStart(3, '0');
						}
						return '';
					case ResultField.PickFour:
						if (typeof this.result.pick_four === 'number') {
							return this.result.pick_four.toString().
								padStart(4, '0');
						}
						return '';
					case ResultField.PickFive:
						if (typeof this.result.pick_five === 'number') {
							return this.result.pick_five.toString().
								padStart(5, '0');
						}
						return '';
					case ResultField.First:
						if (typeof this.result.first_number === 'number') {
							return this.result.first_number.toString().
								padStart(2, '0');
						}
						return '';
					case ResultField.Second:

						if (typeof this.result.second_number === 'number') {
							return this.result.second_number.toString().
								padStart(2, '0');
						}
						return '';
					case ResultField.Third:

						if (typeof this.result.third_number === 'number') {
							return this.result.third_number.toString().
								padStart(2, '0');
						}
						return '';
				}
			}
		},
		computed: {
			sortedResultsFields() {
				return [...this.sortition.result_fields].sort();
			}
		}
	};
</script>

<style lang="scss" scoped>

	.background {
		height: 100vh;
		background: url("../components/common/images/background.jpg");
	}

	img {
		max-height: 130px;
	}

	.big {
		font-size: 2.5em;
		color: white;
	}

	img.lucky-logo {
		max-height: 140px;
	}

	img.winning-numbers {
		max-height: 200px;
	}

	.background {
		height: 100vh;
	}

	.b-l-white {
		border-left: solid 2px white;
	}

	.sortition-name {
		font-size: 1.5em;
	}

	.mb-20 {
		margin-bottom: 20px;
	}

	.ball {
		max-width: 80px;
		margin-top: 10px;
	}
</style>
